"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsManager = void 0;
const analytics_1 = require("firebase/analytics");
const PlatformDetector_1 = require("../platforms/PlatformDetector");
/**
 * Analytics Service Manager
 * Handles Firebase Analytics initialization (web/browser only)
 */
class AnalyticsManager {
    constructor() {
        this.analytics = null;
        this.initialized = false;
    }
    initialize(app) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.initialized) {
                return this.analytics;
            }
            try {
                console.log('📈 AnalyticsManager: Initializing Firebase Analytics...');
                // Analytics only works in browser environment
                if (!PlatformDetector_1.PlatformDetector.isWeb()) {
                    console.log('ℹ️ AnalyticsManager: Analytics not available on this platform');
                    this.analytics = null;
                    this.initialized = true;
                    return this.analytics;
                }
                this.analytics = (0, analytics_1.getAnalytics)(app);
                this.initialized = true;
                console.log('✅ AnalyticsManager: Analytics service initialized');
                return this.analytics;
            }
            catch (error) {
                console.error('❌ AnalyticsManager: Failed to initialize Analytics:', error);
                this.analytics = null;
                this.initialized = true;
                return null;
            }
        });
    }
    getInstance() {
        return this.analytics;
    }
    getAnalytics() {
        return this.analytics; // Analytics can be null, so don't throw
    }
    isInitialized() {
        return this.initialized;
    }
    /**
     * Reset manager for testing purposes
     */
    reset() {
        this.analytics = null;
        this.initialized = false;
    }
}
exports.AnalyticsManager = AnalyticsManager;
